import React, { useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import InputAdornment from '@material-ui/core/InputAdornment';
import StarsIcon from '@material-ui/icons/Stars';
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { permitsList, minPermisos } from 'src/constants/permits';
import Card from 'src/components/sharedComponents/Card/Card';
import Snackbar from 'src/components/sharedComponents/Snackbar/Snackbar';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import TableType2 from 'src/components/sharedComponents/Tablas/TableType2/TableType2';

const GlukyPage = ({
  open,
  lines,
  points,
  columns,
  loading,
  permisos,
  onChange,
  handleCreate,
  handleDelete,
  handleUpdate,
}) => {
  const minValue = permisos[permitsList.GLULY];
  const pointRefs = useRef(null);

  return (
    <>
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="warning"
        icon={AddAlertIcon}
        message="Puntos ya asignados"
        open={open}
      />
      <CardTitle title="Puntos Gluky" />
      <div style={{ margin: '10px' }}>
        {minValue >= minPermisos.CREAR && (
          <Card>
            <CardBody>
              <form
                noValidate
                autoComplete="off"
                onSubmit={handleCreate}
                ref={pointRefs}
              >
                <section>
                  <h5>Asignación de puntos</h5>
                </section>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={5} md={5}>
                    <Autocomplete
                      {...lines}
                      id="select-on-focus"
                      loading={loading}
                      required
                      selectOnFocus
                      onChange={(event, newValue) => onChange(newValue, 'linea')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Lineas"
                          margin="normal"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5} md={5}>
                    <TextField
                      label="Numero de puntos"
                      margin="normal"
                      type="number"
                      fullWidth
                      required
                      onChange={(event) => onChange(event.target.value, 'puntos')}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <StarsIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} md={2}>
                    <Button
                      style={{ width: '100%' }}
                      type="onSubmit"
                      color="warning"
                    >
                      Asignar Puntos
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardBody>
          </Card>
        )}
      </div>
      <TableType2
        hiddenDelete
        loading={loading}
        columns={columns}
        dataTable={points}
        onDelete={handleDelete}
        onUpdate={handleUpdate}
        idPermiso={permitsList.GLULY}
        minValue={permisos[permitsList.GLULY]}
      />
    </>
  );
};

export default GlukyPage;
